var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PeriodMapperConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { Column } from '@symon-ai/wisepipe-common-data';
import { DateConverter, JSON, JsonConverter, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationState } from './validation/toolValidationResult';
import { isSourceValid } from './validation/validateHelper';
export var PeriodType;
(function (PeriodType) {
    PeriodType["Monthly"] = "monthly";
    PeriodType["SemiMonthly"] = "semi_monthly";
    PeriodType["TwoWeek"] = "two_week";
    PeriodType["FourWeek"] = "four_week";
    PeriodType["Weekly"] = "weekly";
})(PeriodType || (PeriodType = {}));
const schema = {
    $id: 'urn:wisepipe-common-pipe:PeriodMapperConfig',
    type: 'object',
    properties: {
        dateColumn: { type: 'string', minLength: 1 },
        newColumnName: { type: 'string', minLength: 1 },
        startDate: { type: 'string', format: 'date-time' },
        endDate: { type: 'string', format: 'date-time' },
        periodType: { type: 'string', enum: Object.values(PeriodType) },
        generatedPeriods: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:DatePeriod' }, minItems: 1 },
        outOfRangeValue: { type: 'string', minLength: 1 }
    },
    required: ['dateColumn', 'newColumnName', 'startDate', 'endDate', 'periodType', 'generatedPeriods']
};
let PeriodMapperConfig = PeriodMapperConfig_1 = class PeriodMapperConfig extends ToolConfig {
    constructor(dateColumn, newColumnName, startDate, endDate, periodType, generatedPeriods, outOfRangeValue, customFormats) {
        super(ToolType.PERIOD_MAPPER, customFormats);
        this.dateColumn = dateColumn;
        this.newColumnName = newColumnName;
        this.startDate = startDate;
        this.endDate = endDate;
        this.periodType = periodType;
        this.generatedPeriods = generatedPeriods;
        this.outOfRangeValue = outOfRangeValue ?? 'Out of range';
        JSON.validate(this, PeriodMapperConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return PeriodMapperConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return PeriodMapperConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return PeriodMapperConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return PeriodMapperConfig_1.outs;
    }
    static get in() {
        return PeriodMapperConfig_1.ins[0];
    }
    static get out() {
        return PeriodMapperConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.PERIOD_MAPPER.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.SPM], this.ins, this.outs, ['period', 'date', 'map'], true);
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const source = ins.schemas.at(this.in);
        const exp = tsb.export(this.out);
        if (source) {
            source.forEach((s) => exp.copy(this.in, s, false, false));
            exp.makeNew(new Column(this.newColumnName, 'string'), undefined, true);
        }
        exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, ins) {
        const source = ins.schemas.at(this.in);
        if (!source) {
            return ToolValidationState.BAD_METADATA;
        }
        const inputs = new Map();
        inputs.set(this.dateColumn, ['date']);
        return isSourceValid(source, inputs, [this.newColumnName])
            ? ToolValidationState.VALID
            : ToolValidationState.BAD_METADATA;
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], PeriodMapperConfig.prototype, "startDate", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], PeriodMapperConfig.prototype, "endDate", void 0);
PeriodMapperConfig = PeriodMapperConfig_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ToolType.PERIOD_MAPPER)
], PeriodMapperConfig);
export { PeriodMapperConfig };
//# sourceMappingURL=periodMapperConfig.js.map